import { createTheme } from '@mui/material/styles';

const fontFamily = ['Hanken Grotesk', 'Helvetica', 'Arial', 'sans-serif'].join(
  ',',
);

const legalInsightsTheme = createTheme({
  palette: {
    // @NOTE: If you change the primary colors, update them also in Article.css
    primary: {
      main: '#467A4D',
      dark: '#315535',
      light: '#6B9470',
    },
    secondary: {
      main: '#00509B',
      dark: '#00386C',
      light: '#3373AF',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.9)',
      secondary: 'rgba(0, 0, 0, 0.7)',
    },
    background: {
      paper: '#FFFFFF',
      default: '#FAFAFA',
    },
  },
  shape: {
    borderRadius: 0,
  },
  typography: {
    fontFamily,
    // fontSize: 20,
    h1: {},
    h2: {},
    h3: {},
    h4: {},
    h5: {},
    h6: {},
    subtitle1: {},
    subtitle2: {},
    body1: {},
    body2: {},
    caption: {},
    overline: {},
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: '1rem',
          padding: 0,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableRipple: false,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          fontWeight: 500,
        },
        outlined: {
          backgroundColor: '#FFFFFF',
        },
        contained: {
          color: '#FFFFFF',
        },
        sizeSmall: {
          fontSize: '14px',
          lineHeight: '150%',
          padding: '4px 5px',
        },
        sizeMedium: {
          fontSize: '16px',
          lineHeight: '150%',
          padding: '6px 8px',
        },
        sizeLarge: {
          fontSize: '18px',
          lineHeight: '149%',
          padding: '8px 11px',
        },
      },
    },
  },
});

legalInsightsTheme.typography.h1 = {
  ...legalInsightsTheme.typography.h1,
  fontSize: '24px',
  fontWeight: 700,
  lineHeight: '130%',
  [legalInsightsTheme.breakpoints.up('sm')]: {
    fontSize: '26px',
  },
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '36px',
  },
};

legalInsightsTheme.typography.h2 = {
  ...legalInsightsTheme.typography.h2,
  fontSize: '20px',
  fontWeight: 700,
  lineHeight: '130%',
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '22px',
  },
};

legalInsightsTheme.typography.h3 = {
  ...legalInsightsTheme.typography.h3,
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '130%',
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '20px',
    fontWeight: 600,
  },
};

legalInsightsTheme.typography.h4 = {
  ...legalInsightsTheme.typography.h4,
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '130%',
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
};

legalInsightsTheme.typography.h5 = {
  ...legalInsightsTheme.typography.h5,
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '130%',
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '16px',
  },
};

legalInsightsTheme.typography.h6 = {
  ...legalInsightsTheme.typography.h6,
  fontSize: '12px',
  fontWeight: 700,
  lineHeight: '130%',
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '14px',
  },
};

legalInsightsTheme.typography.subtitle1 = {
  ...legalInsightsTheme.typography.subtitle1,
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '150%',
  [legalInsightsTheme.breakpoints.up('sm')]: {
    fontSize: '18px',
  },
};

legalInsightsTheme.typography.subtitle2 = {
  ...legalInsightsTheme.typography.subtitle2,
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '150%',
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '16px',
  },
};
legalInsightsTheme.typography.body1 = {
  ...legalInsightsTheme.typography.body1,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '150%',
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
};
legalInsightsTheme.typography.body2 = {
  ...legalInsightsTheme.typography.body2,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '150%',
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '16px',
  },
};
legalInsightsTheme.typography.caption = {
  ...legalInsightsTheme.typography.caption,
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '150%',
  [legalInsightsTheme.breakpoints.up('md')]: {
    fontSize: '14px',
    fontWeight: 400,
  },
};
legalInsightsTheme.typography.overline = {
  ...legalInsightsTheme.typography.overline,
  textTransform: 'uppercase',
  fontSize: '12px',
  fontWeight: 700,
  lineHeight: '150%',
  letterSpacing: '0.1em',
};

legalInsightsTheme.shadows[4] =
  '0px 2px 4px -1px rgba(0, 0, 0, 0.05), 0px 4px 5px 0px rgba(0, 0, 0, 0.03), 0px 1px 10px 0px rgba(0, 0, 0, 0.03)';

export { legalInsightsTheme };
